import React from "react";

const FooterPC = () => {
  return (
    <>
      <footer style={{ boxSizing: "border-box" }}>
        <div
          className="container"
          style={{
            boxSizing: "border-box",
            width: "100%",
            paddingRight: "var(--bs-gutter-x,.75rem)",
            paddingLeft: "var(--bs-gutter-x,.75rem)",
            marginRight: "auto",
            marginLeft: "auto",
            maxWidth: "1400px",
          }}
        >
        </div>
        <div
          id="footerContainer"
          className="top-footer-wraps"
          style={{
            boxSizing: "border-box",
            backgroundColor: "rgb(0,0,0)",
            boxShadow: "rgba(0, 0, 0, 0.05) 0px -8px 24px",
          }}
        >
          <div
            className="govil-t-f container px-lg-5"
            style={{
              boxSizing: "border-box",
              marginLeft: "auto",
              marginRight: "auto",
              width: "100%",
              maxWidth: "1400px",
              display: "flex",
              padding: "2.2rem 0px",
              flexDirection: "row",
              justifyContent: "space-around",
              paddingRight: "3rem",
              paddingLeft: "3rem",
            }}
          >
            <div
              className="footer-col"
              style={{
                boxSizing: "border-box",
                margin: "0px 1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                borderBottom: "none",
                padding: "initial",
              }}
            >
              <h5
                className="title-col"
                style={{
                  boxSizing: "border-box",
                  lineHeight: 1.2,
                  fontWeight: 600,
                  letterSpacing: "0.2px",
                  color: "rgb(236,236,236)",
                  fontSize: "16px",
                  margin: "0px 0px 1rem",
                  marginTop: "0px",
                  marginBottom: "1rem",
                  textAlign: "start",
                }}
              >
                <a
              href="/articles"
              style={{
                boxSizing: "border-box",
                textDecoration: "none",
                fontSize: "14px",
                lineHeight: "1.5rem",
                color: "rgb(236,236,236)",
              }}
            >
                Articles
                </a>
              </h5>
              <div
                className="list-col"
                style={{ boxSizing: "border-box", display: "flex" }}
              >
                <ul
                  id="supportLinks_0"
                  className="footer-link-list"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    margin: "0px",
                    padding: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                    paddingLeft: "0px",
                    textAlign: "start",
                    color: "rgb(236,236,236)",
                  }}
                >
                  <li id="supportLinks_0_00" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/news"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      News
                    </a>
                  </li>
                  <li id="supportLinks_0_0" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/identities"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Identities Wiki
                    </a>
                  </li>
                  <li id="supportLinks_0_1" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/misc"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Miscellaneous
                    </a>
                  </li>
                  <li id="supportLinks_0_2" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/travelinfo"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Safe Travel Information
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="footer-col"
              style={{
                boxSizing: "border-box",
                margin: "0px 1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                borderBottom: "none",
                padding: "initial",
              }}
            >
              <h5
                className="title-col"
                style={{
                  boxSizing: "border-box",
                  lineHeight: 1.2,
                  fontWeight: 600,
                  letterSpacing: "0.2px",
                  color: "rgb(236,236,236)",
                  fontSize: "16px",
                  margin: "0px 0px 1rem",
                  marginTop: "0px",
                  marginBottom: "1rem",
                  textAlign: "start",
                }}
              >
                <a
              href="/forums"
              style={{
                boxSizing: "border-box",
                textDecoration: "none",
                fontSize: "14px",
                lineHeight: "1.5rem",
                color: "rgb(236,236,236)",
              }}
            >
                Forums
                </a>
              </h5>
              <div
                className="list-col"
                style={{ boxSizing: "border-box", display: "flex" }}
              >
                <ul
                  id="supportLinks_1"
                  className="footer-link-list"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    margin: "0px",
                    padding: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                    paddingLeft: "0px",
                    textAlign: "start",
                    color: "rgb(236,236,236)",
                  }}
                >
                  <li id="supportLinks_1_0" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/forums/thailand"
                      rel="nofollow noreferrer"
                      target="_blank"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Thailand
                    </a>
                  </li>
                  <li id="supportLinks_1_1" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/forums/singapore"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Singapore
                    </a>
                  </li>
                  <li id="supportLinks_1_2" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/forums/korea"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      South Korea
                    </a>
                  </li>
                  <li id="supportLinks_1_3" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/forums/israel"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Israel
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="footer-col"
              style={{
                boxSizing: "border-box",
                margin: "0px 1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                borderBottom: "none",
                padding: "initial",
              }}
            >
              <h5
                className="title-col"
                style={{
                  boxSizing: "border-box",
                  lineHeight: 1.2,
                  fontWeight: 600,
                  letterSpacing: "0.2px",
                  color: "rgb(236,236,236)",
                  fontSize: "16px",
                  margin: "0px 0px 1rem",
                  marginTop: "0px",
                  marginBottom: "1rem",
                  textAlign: "start",
                }}
              >
                <a
              href="https://discord.com/invite/GKYEQYcFWZ"
              style={{
                boxSizing: "border-box",
                textDecoration: "none",
                fontSize: "14px",
                lineHeight: "1.5rem",
                color: "rgb(236,236,236)",
              }}
            >
                Discord Server
                </a>
              </h5>
              <div
                className="list-col"
                style={{ boxSizing: "border-box", display: "flex" }}
              >
                <ul
                  id="supportLinks_2"
                  className="footer-link-list"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    margin: "0px",
                    padding: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                    paddingLeft: "0px",
                    textAlign: "start",
                    color: "rgb(236,236,236)",
                  }}
                >
                  <li id="supportLinks_2_0" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/discordmods"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Moderators
                    </a>
                  </li>
                  <li id="supportLinks_2_1" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/discordbot"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      BOT
                    </a>
                  </li>
                  <li id="supportLinks_2_2" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/rules"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Entire Rules
                    </a>
                  </li>
                  <li id="supportLinks_2_3" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/openparliament"
                      rel="nofollow noreferrer"
                      target="_blank"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Open Parliament
                    </a>
                  </li>
                  <li id="supportLinks_2_4" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/election"
                      rel="nofollow noreferrer"
                      target="_blank"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Election
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="footer-col"
              style={{
                boxSizing: "border-box",
                margin: "0px 1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                borderBottom: "none",
                padding: "initial",
              }}
            >
              <h5
                className="title-col"
                style={{
                  boxSizing: "border-box",
                  lineHeight: 1.2,
                  fontWeight: 600,
                  letterSpacing: "0.2px",
                  color: "rgb(236,236,236)",
                  fontSize: "16px",
                  margin: "0px 0px 1rem",
                  marginTop: "0px",
                  marginBottom: "1rem",
                  textAlign: "start",
                }}
              >
                <a
              href="/about"
              style={{
                boxSizing: "border-box",
                textDecoration: "none",
                fontSize: "14px",
                lineHeight: "1.5rem",
                color: "rgb(236,236,236)",
              }}
            >
                About Us
                </a>
              </h5>
              <div
                className="list-col"
                style={{ boxSizing: "border-box", display: "flex" }}
              >
                <ul
                  id="supportLinks_2"
                  className="footer-link-list"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    margin: "0px",
                    padding: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                    paddingLeft: "0px",
                    textAlign: "start",
                    color: "rgb(236,236,236)",
                  }}
                >
                  <li id="supportLinks_2_0" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/projects"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Our Projects
                    </a>
                  </li>
                  <li id="supportLinks_2_0" style={{ boxSizing: "border-box" }}>
                    <a
                      href="/partnerships"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      Partnerships
                    </a>
                  </li>
                  <li id="supportLinks_2_1" style={{ boxSizing: "border-box" }}>
                    <a
                      href="https://prestige-flight.web.app/about"
                      style={{
                        boxSizing: "border-box",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.2px",
                        color: "rgb(236,236,236)",
                      }}
                    >
                      About PrestigeFlight (external)
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="footer-col last-col"
              style={{
                boxSizing: "border-box",
                margin: "0px 1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                borderBottom: "none",
                padding: "initial",
                paddingBottom: "initial",
              }}
            >
              <div
                className="list-col"
                style={{ boxSizing: "border-box", display: "flex" }}
              >
                <ul
                  id="networksList"
                  className="footer-networks-list"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    margin: "0px",
                    padding: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                    paddingLeft: "0px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <li id="networksListe_0" style={{ boxSizing: "border-box" }}>
                    <a
                      aria-labelledby="social0"
                      href="https://dsc.gg/enbybase"
                      rel="nofollow noreferrer"
                      target="_blank"
                      title="EnbyBase Discord"
                      style={{
                        boxSizing: "border-box",
                        margin: "0.5rem",
                        textDecoration: "none",
                        color: "rgb(51, 134, 247)",
                      }}
                    >
                      <svg
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  version="1.1"
  width={32}
  height={32}
  viewBox="0 0 256 256"
  xmlSpace="preserve"
>
  <defs></defs>
  <g
    style={{
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }}
    transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  >
    <path
      d="M 45 0 C 28.967 0 14.902 8.392 6.932 21.015 c 2.729 1.97 6.069 3.145 9.693 3.145 h 32.399 c 17.08 0 32.123 8.704 40.948 21.915 C 89.981 45.716 90 45.36 90 45 C 90 20.147 69.853 0 45 0 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(105,131,205)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(1 0 0 1 0 0) "
      strokeLinecap="round"
    />
    <path
      d="M 90 45 c 0 -1.207 -0.062 -2.399 -0.155 -3.583 C 81.002 27.735 66.02 20.885 49.024 20.885 H 16.625 c -3.159 0 -6.101 -0.494 -8.614 -1.504 C 3.387 26.046 0.51 34.014 0.063 42.629 c 9.023 11.127 22.794 18.247 38.236 18.247 h 0.744 c 9.038 0 13.101 3.942 13.329 12.925 c 0.004 -0.143 0.022 -0.282 0.022 -0.426 c 0 8.417 -3.516 15.355 -11.172 16.456 C 42.469 89.934 43.726 90 45 90 C 69.853 90 90 69.853 90 45 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(97,121,189)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(1 0 0 1 0 0) "
      strokeLinecap="round"
    />
    <path
      d="M 41.27 89.834 c 7.988 -1.072 14.169 -7.802 14.378 -16.034 c -0.228 -8.983 -7.566 -16.2 -16.604 -16.2 h -0.744 c -15.296 0 -28.947 -6.992 -37.973 -17.938 C 0.119 41.414 0 43.193 0 45 C 0 68.595 18.164 87.936 41.27 89.834 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(88,110,172)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(1 0 0 1 0 0) "
      strokeLinecap="round"
    />
    <path
      d="M 13.903 14.081 c -0.507 0 -0.907 0.445 -0.907 0.988 c 0 0.543 0.409 0.988 0.907 0.988 c 0.507 0 0.907 -0.445 0.907 -0.988 C 14.82 14.526 14.41 14.081 13.903 14.081 z M 17.151 14.081 c -0.507 0 -0.907 0.445 -0.907 0.988 c 0 0.543 0.409 0.988 0.907 0.988 c 0.507 0 0.907 -0.445 0.907 -0.988 C 18.058 14.526 17.658 14.081 17.151 14.081 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(255,255,255)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(2.81 0 0 2.81 1.4065934065934016 1.4065934065934016) "
      strokeLinecap="round"
    />
    <path
      d="M 21.475 6.617 H 9.553 c -1.005 0 -1.824 0.819 -1.824 1.833 v 12.028 c 0 1.014 0.819 1.833 1.824 1.833 h 10.089 l -0.472 -1.646 l 1.139 1.059 l 1.077 0.996 l 1.913 1.69 V 8.45 C 23.298 7.435 22.48 6.617 21.475 6.617 z M 18.04 18.236 c 0 0 -0.32 -0.383 -0.587 -0.721 c 1.165 -0.329 1.61 -1.059 1.61 -1.059 c -0.365 0.24 -0.712 0.409 -1.023 0.525 c -0.445 0.187 -0.872 0.311 -1.29 0.383 c -0.854 0.16 -1.637 0.116 -2.304 -0.009 c -0.507 -0.098 -0.943 -0.24 -1.308 -0.383 c -0.205 -0.08 -0.427 -0.178 -0.649 -0.302 c -0.027 -0.018 -0.053 -0.027 -0.08 -0.044 c -0.018 -0.009 -0.027 -0.018 -0.036 -0.027 c -0.16 -0.089 -0.249 -0.151 -0.249 -0.151 s 0.427 0.712 1.557 1.05 c -0.267 0.338 -0.596 0.738 -0.596 0.738 c -1.966 -0.062 -2.714 -1.352 -2.714 -1.352 c 0 -2.865 1.281 -5.187 1.281 -5.187 c 1.281 -0.961 2.5 -0.934 2.5 -0.934 l 0.089 0.107 c -1.601 0.463 -2.34 1.165 -2.34 1.165 s 0.196 -0.107 0.525 -0.258 c 0.952 -0.418 1.708 -0.534 2.02 -0.56 c 0.053 -0.009 0.098 -0.018 0.151 -0.018 c 0.543 -0.071 1.157 -0.089 1.797 -0.018 c 0.845 0.098 1.753 0.347 2.678 0.854 c 0 0 -0.703 -0.667 -2.215 -1.13 l 0.125 -0.142 c 0 0 1.219 -0.027 2.5 0.934 c 0 0 1.281 2.322 1.281 5.187 C 20.763 16.884 20.007 18.174 18.04 18.236 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(255,255,255)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(2.81 0 0 2.81 1.4065934065934016 1.4065934065934016) "
      strokeLinecap="round"
    />
  </g>
</svg>
                    </a>
                  </li>
                  <li id="networksListe_1" style={{ boxSizing: "border-box" }}>
                    <a
                      aria-labelledby="social1"
                      href="https://reddit.com/r/enbybase"
                      rel="nofollow noreferrer"
                      target="_blank"
                      title="EnbyBase SubReddit"
                      style={{
                        boxSizing: "border-box",
                        margin: "0.5rem",
                        textDecoration: "none",
                        color: "rgb(51, 134, 247)",
                      }}
                    >
                      <svg
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  version="1.1"
  width={32}
  height={32}
  viewBox="0 0 256 256"
  xmlSpace="preserve"
>
  <defs></defs>
  <g
    style={{
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }}
    transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  >
    <circle
      cx={45}
      cy={45}
      r={45}
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(255,69,0)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform="  matrix(1 0 0 1 0 0) "
    />
    <path
      d="M 75.011 45 c -0.134 -3.624 -3.177 -6.454 -6.812 -6.331 c -1.611 0.056 -3.143 0.716 -4.306 1.823 c -5.123 -3.49 -11.141 -5.403 -17.327 -5.537 l 2.919 -14.038 l 9.631 2.025 c 0.268 2.472 2.483 4.262 4.955 3.993 c 2.472 -0.268 4.262 -2.483 3.993 -4.955 s -2.483 -4.262 -4.955 -3.993 c -1.421 0.145 -2.696 0.973 -3.4 2.204 L 48.68 17.987 c -0.749 -0.168 -1.499 0.302 -1.667 1.063 c 0 0.011 0 0.011 0 0.022 l -3.322 15.615 c -6.264 0.101 -12.36 2.025 -17.55 5.537 c -2.64 -2.483 -6.801 -2.36 -9.284 0.291 c -2.483 2.64 -2.36 6.801 0.291 9.284 c 0.515 0.481 1.107 0.895 1.767 1.186 c -0.045 0.66 -0.045 1.32 0 1.98 c 0 10.078 11.745 18.277 26.23 18.277 c 14.485 0 26.23 -8.188 26.23 -18.277 c 0.045 -0.66 0.045 -1.32 0 -1.98 C 73.635 49.855 75.056 47.528 75.011 45 z M 30.011 49.508 c 0 -2.483 2.025 -4.508 4.508 -4.508 c 2.483 0 4.508 2.025 4.508 4.508 s -2.025 4.508 -4.508 4.508 C 32.025 53.993 30.011 51.991 30.011 49.508 z M 56.152 62.058 v -0.179 c -3.199 2.405 -7.114 3.635 -11.119 3.468 c -4.005 0.168 -7.919 -1.063 -11.119 -3.468 c -0.425 -0.515 -0.347 -1.286 0.168 -1.711 c 0.447 -0.369 1.085 -0.369 1.544 0 c 2.707 1.98 6.007 2.987 9.362 2.83 c 3.356 0.179 6.667 -0.783 9.407 -2.74 c 0.492 -0.481 1.297 -0.47 1.779 0.022 C 56.655 60.772 56.644 61.577 56.152 62.058 z M 55.537 54.34 c -0.078 0 -0.145 0 -0.224 0 l 0.034 -0.168 c -2.483 0 -4.508 -2.025 -4.508 -4.508 s 2.025 -4.508 4.508 -4.508 s 4.508 2.025 4.508 4.508 C 59.955 52.148 58.02 54.239 55.537 54.34 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(255,255,255)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(1 0 0 1 0 0) "
      strokeLinecap="round"
    />
  </g>
</svg>
                    </a>
                  </li>
                  <li id="networksListe_2" style={{ boxSizing: "border-box" }}>
                    <a
                      aria-labelledby="social2"
                      href="https://www.youtube.com/@enbybase"
                      rel="nofollow noreferrer"
                      target="_blank"
                      title="EnbyBase YouTube"
                      style={{
                        boxSizing: "border-box",
                        margin: "0.5rem",
                        textDecoration: "none",
                        color: "rgb(51, 134, 247)",
                      }}
                    >
                      <svg
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  version="1.1"
  width={32}
  height={32}
  viewBox="0 0 256 256"
  xmlSpace="preserve"
>
  <defs></defs>
  <g
    style={{
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }}
    transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  >
    <path
      d="M 45 0 C 28.967 0 14.902 8.392 6.932 21.015 c 2.729 1.97 6.069 3.145 9.693 3.145 h 32.399 c 17.08 0 32.123 8.704 40.948 21.915 C 89.981 45.716 90 45.36 90 45 C 90 20.147 69.853 0 45 0 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(255,0,0)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(1 0 0 1 0 0) "
      strokeLinecap="round"
    />
    <path
      d="M 90 45 c 0 -1.207 -0.062 -2.399 -0.155 -3.583 C 81.002 27.735 66.02 20.885 49.024 20.885 H 16.625 c -3.159 0 -6.101 -0.494 -8.614 -1.504 C 3.387 26.046 0.51 34.014 0.063 42.629 c 9.023 11.127 22.794 18.247 38.236 18.247 h 0.744 c 9.038 0 13.101 3.942 13.329 12.925 c 0.004 -0.143 0.022 -0.282 0.022 -0.426 c 0 8.417 -3.516 15.355 -11.172 16.456 C 42.469 89.934 43.726 90 45 90 C 69.853 90 90 69.853 90 45 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(241,0,0)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(1 0 0 1 0 0) "
      strokeLinecap="round"
    />
    <path
      d="M 55.669 73.375 c 0 0.144 -0.018 0.283 -0.021 0.426 v 0 C 55.651 73.658 55.669 73.518 55.669 73.375 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(255,255,255)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(1 0 0 1 0 0) "
      strokeLinecap="round"
    />
    <path
      d="M 41.27 89.834 c 7.988 -1.072 14.169 -7.802 14.378 -16.034 c -0.228 -8.983 -7.566 -16.2 -16.604 -16.2 h -0.744 c -15.296 0 -28.947 -6.992 -37.973 -17.938 C 0.119 41.414 0 43.193 0 45 C 0 68.595 18.164 87.936 41.27 89.834 z"
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(228,0,0)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform=" matrix(1 0 0 1 0 0) "
      strokeLinecap="round"
    />
    <polygon
      points="29.38,66.5 66.62,45 29.38,23.5 "
      style={{
        stroke: "none",
        strokeWidth: 1,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "rgb(255,255,255)",
        fillRule: "nonzero",
        opacity: 1
      }}
      transform="  matrix(1 0 0 1 0 0) "
    />
  </g>
</svg>
                    </a>
                  </li>
                </ul>
                
              </div>
              
              
        <span id="site-copyright" style={{ boxSizing: "inherit" }}>
        TransBase Group <br /> 10050号
          </span>
            </div>
          </div>
        </div>
        
      </footer></>
  );
}

export default FooterPC;